import React from 'react'
import { Disclosure } from '@cred/react-disclosures-sdk'

const disclamers = {
  ups: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.upstart" />,
  pro: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.prosper" />,
  frp: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.freedom-plus" />,
  marlette: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.marlette" />,
  marcus: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.marcus" />,
  lightstream: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.lightstream" />,
  upgrade: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.upgrade" />,
  'lending-point': <Disclosure required={false} slug="partners-widgets.personal.disclaimer.lending-point" />,
  ldc: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.lending-club" />,
  payoff: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.payoff" />,
  axos: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.axos" />,
  sofi: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.sofi" />,
  ava: <Disclosure required={false} slug="partners-widgets.personal.disclaimer.avant" />,
}

export default disclamers
